import { doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';

const userDoc = (userId) => doc(db, 'users', userId);
const albumDoc = (userId, albumId) => doc(db, 'users', userId, 'albums', albumId);
const stickersDoc = (userId, albumId) => doc(db, 'users', userId, 'stickers', albumId);

export const fbLoadAlbums = async (userId) => {
  try {
    const snap = await getDoc(userDoc(userId));
    return snap.exists() ? (snap.data().albums || []) : null;
  } catch {
    return null;
  }
};

export const fbSaveAlbums = async (userId, albums) => {
  try {
    await setDoc(userDoc(userId), { albums, updatedAt: Date.now() }, { merge: true });
    return true;
  } catch {
    return false;
  }
};

export const fbLoadStickers = async (userId, albumId) => {
  try {
    const snap = await getDoc(stickersDoc(userId, albumId));
    return snap.exists() ? snap.data().stickers : null;
  } catch {
    return null;
  }
};

export const fbSaveStickers = async (userId, albumId, stickers) => {
  try {
    await setDoc(stickersDoc(userId, albumId), { stickers, updatedAt: Date.now() });
    return true;
  } catch {
    return false;
  }
};

export const fbDeleteAlbum = async (userId, albumId) => {
  try {
    await deleteDoc(albumDoc(userId, albumId));
    await deleteDoc(stickersDoc(userId, albumId));
    return true;
  } catch {
    return false;
  }
};

export const fbUserExists = async (userId) => {
  try {
    const snap = await getDoc(userDoc(userId));
    return snap.exists();
  } catch {
    return false;
  }
};
